import { render, staticRenderFns } from "./activity_data_statistics_new.vue?vue&type=template&id=b56c0480&scoped=true"
import script from "./activity_data_statistics_new.vue?vue&type=script&lang=js"
export * from "./activity_data_statistics_new.vue?vue&type=script&lang=js"
import style0 from "./activity_data_statistics_new.vue?vue&type=style&index=0&id=b56c0480&prod&lang=scss"
import style1 from "./activity_data_statistics_new.vue?vue&type=style&index=1&id=b56c0480&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56c0480",
  null
  
)

export default component.exports